import React from "react";
import { Link } from "react-router-dom";
import { FaTripadvisor } from "react-icons/fa";
import {TbView360Number} from "react-icons/tb";
import {FaFacebook, FaXTwitter, FaInstagram, FaGoogle} from "react-icons/fa6";
import styled from "styled-components";

const Socs = styled.div`
    background: ${({content}) => content.titleBgColor};
    a { color: ${({content}) => content.titleTextColor};}
    font-size: 1.25rem;
    display: flex;
    padding: 5px;
    flex-wrap: wrap;
    column-gap: 30px;
    justify-content: flex-start;
    align-items: flex-start;
`;

export default function Socials({content}) {

    return(
        <Socs content={content.styles}>
            {(content.socials.facebook && content.socials.facebook.length > 10) ? <Link to={content.socials.facebook}><FaFacebook/></Link> :<></>}
            {(content.socials.google && content.socials.google.length > 10) ? <Link to={content.socials.google}><FaGoogle/></Link> :<></>}
            {(content.socials.google360 && content.socials.google360.length > 10) ? <Link to={content.socials.google360}><TbView360Number/></Link> :<></>}
            {(content.socials.instagram && content.socials.instagram.length > 10) ? <Link to={content.socials.instagram}><FaInstagram/></Link> :<></>}
            {(content.socials.tripAdvisor && content.socials.tripAdvisor.length > 10) ? <Link to={content.socials.tripAdvisor}><FaTripadvisor/></Link> :<></>}
            {(content.socials.X && content.socials.X.length > 10) ? <Link to={content.socials.X}><FaXTwitter/></Link> :<></>}
        </Socs>
    )
}
